<template>
  <div class="app-container" v-show="isLogin">
    <div style="height: 110px">
      <span
        style="
          border-bottom: 2px solid #2cafe7;
          font-size: 16px;
          color: black;
          padding-bottom: 4px;
          padding-left: 10px;
          padding-right: 10px;
        "
        >生成卡密</span
      >
      <hr color="#dcdfe6" width="100%" />
      代发仓库：
      <el-select
        style="width: 400px; margin-top: 15px"
        v-model="kamiCreate.pingtai_data_id"
        @change="cangkuClick"
        placeholder="代发仓库"
        class="filter-item"
      >
        <el-option
          v-for="item in cangkuList"
          :key="item.id"
          :label="item.desc_name"
          :value="item.id"
        >
          <span>
            <img
              :src="item.kuaidi.pic"
              alt="图标"
              style="width: 60px; height: 30px; margin-right: 8px"
            />
            {{ item.desc_name }}
          </span>
        </el-option>
      </el-select>
      &nbsp;&nbsp;&nbsp; 单价：<el-input
        v-model="price"
        style="width: 80px"
        :readonly="true"
      ></el-input>
      &nbsp;&nbsp;&nbsp; 条数：<el-select
        v-model="kamiCreate.strip"
        style="width: 90px"
        class="filter-item"
        @change="stripOrZhangChange"
      >
        <el-option
          v-for="(item, index) in stripList"
          :key="index"
          :label="item"
          :value="item"
        />
      </el-select>
      &nbsp;&nbsp;&nbsp; 张数：<el-input
        v-model="kamiCreate.zhang"
        style="width: 90px"
        placeholder="0"
        class="input-num"
        :min="0"
        onkeyup="this.value = this.value.replace(/^(0+)|[^\d]+/g,'')"
        @blur="stripOrZhangChange"
      />
      &nbsp;&nbsp;&nbsp; 金额：<el-input
        v-model="totalMoney"
        style="width: 80px"
        :readonly="true"
      ></el-input>
      <el-input
        v-model="kamiCreate.money"
        style="width: 80px"
        :readonly="true"
        v-show="false"
      ></el-input>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-button
        type="primary"
        style="
          font-size: 13px;
          background-color: #0850fc;
          color: white;
          height: 38px;
          border-radius: 0.4em;
        "
        @click="creatKami"
        >生成卡密</el-button
      >
    </div>
    <span
      style="
        border-bottom: 2px solid #2cafe7;
        font-size: 16px;
        color: black;
        padding-bottom: 4px;
        padding-left: 10px;
        padding-right: 10px;
      "
      >卡密列表</span
    >
    <hr color="#dcdfe6" width="100%" />
    <div style="margin-top: 15px">
      状态：<input type="radio" :value="0" v-model="listQuery.status" />
      <label>未充值</label>&nbsp;&nbsp;
      <input type="radio" :value="1" v-model="listQuery.status" /> <label>已充值</label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-button
        icon="el-icon-search"
        type="primary"
        style="
          font-size: 13px;
          background-color: #0850fc;
          color: white;
          height: 38px;
          border-radius: 0.4em;
        "
        @click="getList(1)"
        >查询</el-button
      >
      <el-button
        icon="el-icon-download"
        type="primary"
        :loading="downloadLoading"
        style="
          font-size: 13px;
          background-color: white;
          color: #0850fc;
          height: 38px;
          border-radius: 0.4em;
          padding: 0 0 0 6px;
        "
        @click="exportExcel(1)"
        >导出（已充值）</el-button
      >

      <el-button
        icon="el-icon-download"
        type="primary"
        style="
          font-size: 13px;
          background-color: white;
          color: #0850fc;
          height: 38px;
          border-radius: 0.4em;
          padding: 0 0 0 6px;
        "
        @click="exportExcel(0)"
        >导出（未充值）</el-button
      >
    </div>
    <el-table
      v-show="this.listQuery.button == 1"
      v-loading="listLoading"
      :data="list"
      highlight-current-row
      style="color: rgb(70, 70, 70); margin-top: 10px"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '3px 0' }"
      :header-cell-style="{
        background: 'rgb(247 248 252) !important',
        color: '#ededed  !important',
        padding: '7px 0',
        color: 'rgb(140, 140, 140)',
      }"
    >
      <el-table-column label="ID" align="left" min-width="1">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="卡密号" min-width="3" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.no">{{ row.no }}</span>
        </template>
      </el-table-column>
      <el-table-column label="快递仓库" min-width="3" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.pingtai_data_cang">{{
            row.pingtai_data_cang
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单数" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.strip }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否充值" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ isApplyed }}</span>
        </template>
      </el-table-column>
      <el-table-column label="使用者账户" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span v-if="row.user != null">{{ row.user.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="生成时间" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.created_at">{{ row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="使用时间" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.updated_at">{{ row.updated_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="1" align="left" v-if="isShow">
        <template slot-scope="{ row, $index }">
          <el-button
            type="primary"
            style="padding-left: 8px; padding-right: 8px"
            size="mini"
            @click="quitKami(row)"
          >
            申请退卡
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0 && this.listQuery.button == 1"
      :total="total"
      :page.sync="listQuery.page"
      layout="total, prev, pager, next"
      style="padding-top: 12px; padding-bottom: 0px; text-align: center"
      @pagination="getList(1)"
    />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  name: "dltg",
  components: {
    Pagination,
  },
  data() {
    return {
      isLogin: false,
      cangkuList: [],
      kamiCreate: { pingtai_data_id: "", strip: 0, zhang: 1, money: "" },
      totalMoney: "",
      stripList: [0, 50, 100, 200, 300, 500, 1000, 2000, 5000],
      price: "",
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        per_page: 15,
        button: 1,
        status: 0,
      },
      isShow: true,
      isApplyed: "未充值",
      downloadLoading: false,
      exportList: [],
      platform: 1,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.getCk();
    this.getList(1);
    this.registerUrl =
      "http://" + this.$root.localUrl + "/register?uid=" + Cookies.get("view_code");
  },
  methods: {
    getList(btn) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            Cookies.set("view_historyPath", "/dltg", { expires: 1 });
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.listQuery.button = btn;

      this.list = [];
      this.yongjinList = [];
      this.yjsqList = [];

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/kami";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            if (btn == 1) {
              this.list = resd.data.data;
              this.total = resd.data.total;
              if (this.listQuery.status == 1) {
                this.isShow = false;
                this.isApplyed = "已充值";
              } else {
                this.isShow = true;
                this.isApplyed = "未充值";
              }
            }
            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
    getCk() {
      //更换平台时，调用接口获取平台对应仓库列表
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getCk";
      const system_id = Cookies.get("view_system_id");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { platform: this.platform, system_id: system_id },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.cangkuList = resd.data;
            this.cangkuList.forEach((item) => {
              // 快递图标加前缀
              item.kuaidi.pic = this.$root.staticUrl + "storage/" + item.kuaidi.pic;
              // 仓库名称后面加上价格展示
              item.desc_name = item.desc_name + "，￥" + item.processed_member;
            });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    cangkuClick() {
      const selected_cid = this.kamiCreate.pingtai_data_id;
      // 使用forEach方法遍历数组并取值
      this.cangkuList.forEach((item, index) => {
        const cid = item.id;
        if (cid == selected_cid) {
          // 单价
          this.price = item.processed_member;
          // 总金额
          this.totalMoney = (
            this.price *
            this.kamiCreate.strip *
            this.kamiCreate.zhang
          ).toFixed(2);
          // 向后台传值单张金额
          this.creatKami.money = (this.price * this.kamiCreate.strip).toFixed(2);
        }
      });
    },
    creatKami() {
      //更换平台时，调用接口获取平台对应仓库列表
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }
      const url = this.$root.commonPreUrl + "/index/creatKami";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.kamiCreate,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (response.status == "200") {
            this.$notify({
              title: "成功",
              message: "已生成，可在列表查看",
              type: "success",
              duration: 2000,
            });
            // this.getList(1);
            window.location.reload();
          } else {
            this.$confirm(response.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    stripOrZhangChange() {
      // 总金额
      this.totalMoney = (
        this.price *
        this.kamiCreate.strip *
        this.kamiCreate.zhang
      ).toFixed(2);

      this.kamiCreate.money = (this.price * this.kamiCreate.strip).toFixed(2);
    },
    exportExcel(status) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.downloadLoading = true;
      const url = this.$root.commonPreUrl + "/index/export";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { status: status },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.exportList = resd.data;

            import("@/vendor/Export2Excel").then((excel) => {
              // ID	卡密号	快递仓库	单数	金额	使用者账户	是否充值	生成时间	使用时间
              const tHeader = [
                "ID",
                "卡密号",
                "快递仓库",
                "单数",
                "金额",
                "是否充值",
                "生成时间",
                "使用时间",
              ];
              const filterVal = [
                "id",
                "no",
                "pingtai_data_id",
                "strip",
                "money",
                "chongzhi_id",
                "created_at",
                "updated_at",
              ];
              const data = this.formatJson(filterVal);
              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: "table-list",
              });
              this.downloadLoading = false;
            });
          } else {
            this.$confirm(resd.msg, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
    },
    formatJson(filterVal) {
      return this.exportList.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    quitKami(row) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.$confirm("确定要申请退卡吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const yongjin = this.temp.money;
          if (row.chongzhi_id != 0) {
            // alert("卡密已经充值 不支持直接退款！");
            this.$confirm("卡密已经充值 不支持直接退款！", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                return;
              })
              .catch(() => {});
            return;
          }
          const url = this.$root.commonPreUrl + "/index/quitKami";
          const res = axios.get(url, {
            headers: {
              Authorization: "Bearer " + userToken,
            },
            params: { id: row.id },
          });
          res
            .then((response) => {
              const resd = response.data;
              if (resd.code == "200") {
                this.$notify({
                  title: "成功",
                  message: resd.message,
                  type: "success",
                  duration: 2000,
                });
                // this.getList(1);
                window.location.reload();
              } else {
                // alert(resd.message);
                this.$confirm(resd.message, "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, //是否显示取消按钮
                })
                  .then(() => {
                    return;
                  })
                  .catch(() => {});
              }
              setTimeout(() => {
                return;
              }, 1.5 * 1000);
            })
            .catch((error) => {
              console.error("初始请求失败:", error);
              if (
                JSON.stringify(error).includes(
                  "Error: Request failed with status code 401"
                )
              ) {
                this.$confirm("登录信息已失效，请重新登录!", "提示", {
                  confirmButtonText: "确认",
                  showCancelButton: false, //是否显示取消按钮
                })
                  .then(() => {
                    // 重新导航到首页
                    localStorage.clear();
                    this.$root.removeCookies();
                    this.$router.push({ path: "/login" });
                  })
                  .catch(() => {});
              }

              return;
            });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
    },
  },
};
</script>

<style>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/dltg/kmlb/index.vue